var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-flex',{staticClass:"mb-3"},[_c('list',{attrs:{"hideCreate":"true"}})],1),_c('v-divider'),_c('invite')],1)}
var staticRenderFns = []

export { render, staticRenderFns }